module.exports = __webpack_public_path__ + "img/cbd79cb.jpg";